/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ALL_STATUS, ORDER_HISTORY_DATE_FILTER_TWO_YEARS } from '../../configuration/order-history';
import { trackedAction } from '../../utilities/track-execution-time';
import { action as getOrderHistory, GetOrderHistoryInput, IGetOrderHistoryData } from './get-order-history.action';

/**
 * Order history input shared by all dashboard modules.
 *
 * Unlike {@link GetOrderHistoryInput} the cache key is deterministic (no timestamp), so every dashboard module
 * requesting the same status / date range resolves to a single GetHistory call per request instead of one per module.
 */
export class GetDashboardOrderHistoryInput extends GetOrderHistoryInput {
    public getCacheKey = () => `GetDashboardOrderHistory-${this.userToken}-${this.status}-${this.numMonths}`;
    public getCacheObjectType = () => 'GetDashboardOrderHistory';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput =>
    new GetDashboardOrderHistoryInput(args, ALL_STATUS, ORDER_HISTORY_DATE_FILTER_TWO_YEARS);

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetOrderHistoryData>>((input, ctx) => trackedAction(getOrderHistory, input, ctx, 'GetHistory')),
    id: 'GetDashboardOrderHistory',
    input: createInput
});
